/**
 * @Author:
 * @Description:
 * @DateTime: Created in 12:27 2019-10-27
 */
 import EnumItem, { enumMixn } from "./enumItem";

 let EnumFileType =  {
     1:		new EnumItem('目录', 1),
     2:		new EnumItem('文件', 2),
     ...enumMixn
 }
 
 export default EnumFileType
 